<template>
    <app-layout>
        <heading>
            <template #heading>Following</template>
            <template #subheading>List of challenges you are following.</template>
        </heading>

        <div class="mx-auto px-2 py-6 max-w-7xl sm:px-6 sm:py-10 lg:px-8">
            <!-- This example requires Tailwind CSS v2.0+ -->
            <ul class="grid gap-6 grid-cols-1 sm:grid-cols-2 md:grid-cols-3">
                <li v-for="post in favorites" class="flex flex-col col-span-1 bg-white rounded-lg shadow divide-gray-200 divide-y">
                    <div class="relative flex flex-1 flex-col">
                        <Link :href="post.show_url" class="aspect-w-8 aspect-h-4 group sm:aspect-w-10 sm:aspect-h-5 w-full rounded-tl rounded-tr overflow-hidden" v-html="post.images[0]"></Link>
                        <Link :href="post.show_url" class="block p-6">
                            <h3 class="text-gray-900 text-lg font-medium truncate">{{ post.title }}</h3>
                            <h4 class="line-clamp-2 mt-1 text-gray-600 text-sm font-medium truncate">{{ post.text }}</h4>
                        </Link>
                    </div>
                </li>

                <!-- More people... -->
            </ul>

            <!--            <ul role="list" class="grid grid-cols-2 gap-x-4 gap-y-8 sm:grid-cols-3 sm:gap-x-6 lg:grid-cols-4 xl:gap-x-8">-->
            <!--                &lt;!&ndash; Current: "ring-2 ring-offset-2 ring-indigo-500", Default: "focus-within:ring-2 focus-within:ring-offset-2 focus-within:ring-indigo-500" &ndash;&gt;-->

            <!--                <li v-for="favorite in favorites" class="relative">-->
            <!--                    <div class="focus-within:ring-2 focus-within:ring-offset-2 focus-within:ring-indigo-500 group block w-full aspect-w-10 aspect-h-7 rounded-lg overflow-hidden">-->
            <!--                        <div class="focus-within:ring-2 focus-within:ring-offset-2 focus-within:ring-indigo-500 group block w-full aspect-w-10 aspect-h-7 rounded-lg overflow-hidden" v-html="favorite.image"></div>-->
            <!--                        <Link :href="route('posts.show', {post:favorite.id, user: favorite.user.tag})" class="absolute inset-0"></Link>-->
            <!--                    </div>-->
            <!--                    <button @click="favoritePost(favorite)" class="mt-2 block text-sm font-medium text-red-500">Remove</button>-->
            <!--                </li>-->

            <!--            </ul>-->

            <no-results :show="!favorites.length">No Bookmarks</no-results>
        </div>
    </app-layout>
</template>

<script>
import AppLayout from "@/Layouts/AppLayout"
import Button from "@/Jetstream/Button"
import NoResults from "@/Jetstream/NoResults"
import Heading from "@/Components/Heading"
import Textarea from "@/Jetstream/Textarea"

export default {
    name: "Following",

    props: ["favorites"],

    components: {
        Textarea,
        Heading,
        NoResults,
        Button,
        AppLayout,
    },

    computed: {},

    data() {
        return {
            favoriteForm: this.$inertia.form({
                _method: "POST",
            }),
        }
    },

    methods: {
        favoritePost(post) {
            this.favoriteForm.post(
                post.favorite_url,
                {
                    errorBag: "favoritePost",
                },
                {
                    preserveScroll: true,
                }
            )
        },
    },
}
</script>
